import React, { useEffect, useState, useRef } from 'react';
import api from '../api';

// ── SABITLER ─────────────────────────────────────────────
const INTERESTS = ['🎵 Müzik','🎮 Oyun','🌍 Seyahat','📚 Kitap','🍕 Yemek','🏃 Spor','🎬 Film','🐾 Hayvan','💃 Dans','🎨 Sanat','💻 Teknoloji','🌿 Doğa'];
const CITIES = ['İstanbul','Ankara','İzmir','Bursa','Antalya','Adana','Konya','Gaziantep','Kayseri','Eskişehir','Trabzon','Samsun','Diyarbakır','Muğla','Manisa','Balıkesir'];
const TIER = { free:{l:'Ücretsiz',i:'🆓',c:'#64748b'}, plus:{l:'Plus',i:'💙',c:'#3b82f6'}, gold:{l:'Gold',i:'💛',c:'#d97706'} };
const REPORT_REASONS = { fake:'🤡 Sahte', inappropriate:'🔞 Uygunsuz', harassment:'💬 Taciz', spam:'🗑️ Spam', other:'❓ Diğer' };

function Avatar({ name='?', size=38 }) {
  const hue = (name.charCodeAt(0)||72)*137%360;
  return <div style={{ width:size, height:size, borderRadius:'50%', flexShrink:0, background:`hsl(${hue},50%,40%)`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:size*0.38, fontWeight:700, color:'#fff' }}>{name.substring(0,2).toUpperCase()}</div>;
}

function Badge({ children, color='var(--text3)', bg='var(--surface3)' }) {
  return <span style={{ fontSize:11, padding:'2px 8px', borderRadius:20, background:bg, color, border:`1px solid ${color}30`, fontWeight:600 }}>{children}</span>;
}

function StatBox({ label, value, icon, color='var(--teal)', sub, topColor }) {
  return (
    <div style={{ background:'var(--surface)', border:'1px solid var(--border3)', borderTop:`3px solid ${topColor||color}`, borderRadius:'var(--radius)', padding:'14px 16px', flex:1, minWidth:0, position:'relative', overflow:'hidden' }}>
      <div style={{ position:'absolute', right:12, top:12, fontSize:24, opacity:0.1 }}>{icon}</div>
      <div style={{ fontSize:24, fontWeight:800, color, fontFamily:'Plus Jakarta Sans', lineHeight:1 }}>{typeof value==='number'?value.toLocaleString('tr-TR'):(value||'0')}</div>
      <div style={{ fontSize:10, color:'var(--text3)', fontWeight:600, textTransform:'uppercase', letterSpacing:0.4, marginTop:4 }}>{label}</div>
      {sub&&<div style={{ fontSize:10, color:'var(--text3)', marginTop:2 }}>{sub}</div>}
    </div>
  );
}

function Toast({ msg }) {
  if (!msg) return null;
  const ok = !msg.startsWith('❌');
  return <div style={{ position:'fixed', top:20, right:20, zIndex:9999, background:ok?'#f0fdf4':'#fef2f2', color:ok?'#166534':'#dc2626', border:`1px solid ${ok?'#bbf7d0':'#fca5a5'}`, borderRadius:'var(--radius-sm)', padding:'10px 18px', fontSize:13, fontWeight:600, boxShadow:'var(--shadow-md)' }}>{msg}</div>;
}

// ══════════════════════════════════════════════════════════
// ANA BİLEŞEN
// ══════════════════════════════════════════════════════════
export default function DateBot() {
  const [bots, setBots] = useState([]);
  const [selBot, setSelBot] = useState(null);
  const [tab, setTab] = useState('overview');
  const [stats, setStats] = useState({});
  const [toast, setToast] = useState('');

  // Bot users
  const [botUsers, setBotUsers] = useState([]);
  const [botUserFilter, setBotUserFilter] = useState('all');
  const [botUserDetail, setBotUserDetail] = useState(null);
  const [showBotUserForm, setShowBotUserForm] = useState(false);
  const [editBotUser, setEditBotUser] = useState(null);

  // Real users
  const [users, setUsers] = useState([]);
  const [userTotal, setUserTotal] = useState(0);
  const [userSearch, setUserSearch] = useState('');
  const [userFilter, setUserFilter] = useState('all');
  const [userDetail, setUserDetail] = useState(null);

  // Reports
  const [reports, setReports] = useState([]);

  // Chats
  const [chats, setChats] = useState([]);
  const [chatTotal, setChatTotal] = useState(0);
  const [selChat, setSelChat] = useState(null);
  const [chatMessages, setChatMessages] = useState([]);
  const [adminMsg, setAdminMsg] = useState('');
  const [sendingMsg, setSendingMsg] = useState(false);
  const chatEndRef = useRef(null);
  const [chatSearch, setChatSearch] = useState('');

  // Photo moderation
  const [photoMod, setPhotoMod] = useState([]);

  // Word filter
  const [wordFilter, setWordFilter] = useState([]);
  const [newWord, setNewWord] = useState({ word:'', action:'warn' });

  // Settings
  const [settings, setSettings] = useState({});
  const [showSettings, setShowSettings] = useState(false);

  // Add bot
  const [showAddBot, setShowAddBot] = useState(false);
  const [addForm, setAddForm] = useState({ name:'', token:'' });
  const [addLoading, setAddLoading] = useState(false);

  useEffect(() => { loadBots(); }, []);
  useEffect(() => { if(selBot) { loadStats(); loadBotUsers(); loadUsers(); loadReports(); loadChats(); loadPhotoMod(); loadWordFilter(); loadSettings(); } }, [selBot]);
  useEffect(() => { if(selBot) loadUsers(); }, [userSearch, userFilter]);
  useEffect(() => { if(selBot) loadChats(); }, [chatSearch]);

  function msg(m) { setToast(m); setTimeout(()=>setToast(''),4000); }

  async function loadBots() {
    try { const r=await api.get('/datebot'); setBots(r.data); if(r.data.length&&!selBot) setSelBot(r.data[0]); } catch(e){}
  }
  async function loadStats() {
    try { const r=await api.get(`/datebot-manage/${selBot.id}/stats`); setStats(r.data); } catch(e){}
  }
  async function loadBotUsers() {
    try { const r=await api.get(`/datebot-manage/${selBot.id}/bot-users`,{params:{gender:botUserFilter==='all'?'':botUserFilter}}); setBotUsers(r.data); } catch(e){}
  }
  async function loadUsers() {
    try { const r=await api.get(`/datebot-manage/${selBot.id}/users`,{params:{search:userSearch,filter:userFilter}}); setUsers(r.data.users||[]); setUserTotal(r.data.total||0); } catch(e){}
  }
  async function loadReports() {
    try { const r=await api.get(`/datebot-manage/${selBot.id}/reports`); setReports(r.data||[]); } catch(e){}
  }
  async function loadChats() {
    try { const r=await api.get(`/datebot-manage/${selBot.id}/chats`,{params:{search:chatSearch}}); setChats(r.data.chats||[]); setChatTotal(r.data.total||0); } catch(e){}
  }
  async function loadChatMessages(matchId) {
    try { const r=await api.get(`/datebot-manage/${selBot.id}/chats/${matchId}/messages`); setChatMessages(r.data||[]); } catch(e){}
  }
  async function loadPhotoMod() {
    try { const r=await api.get(`/datebot-manage/${selBot.id}/photo-moderation`); setPhotoMod(r.data||[]); } catch(e){}
  }
  async function loadWordFilter() {
    try { const r=await api.get(`/datebot-manage/${selBot.id}/word-filter`); setWordFilter(r.data||[]); } catch(e){}
  }
  async function loadSettings() {
    try { const r=await api.get(`/datebot-manage/${selBot.id}/settings`); setSettings(r.data||{}); } catch(e){}
  }

  async function addBotFn(e) {
    e.preventDefault();
    setAddLoading(true);
    try { const r=await api.post('/datebot/create',addForm); msg(`✅ ${r.data.botInfo?.username||addForm.name} bağlandı!`); setShowAddBot(false); setAddForm({name:'',token:''}); loadBots(); } catch(e){ msg('❌ '+(e.response?.data?.error||e.message)); }
    setAddLoading(false);
  }

  async function saveBotUser(form) {
    try {
      if(editBotUser) { await api.put(`/datebot-manage/${selBot.id}/bot-users/${editBotUser.id}`,form); msg('✅ Bot kullanıcı güncellendi'); }
      else { await api.post(`/datebot-manage/${selBot.id}/bot-users`,form); msg('✅ Bot kullanıcı eklendi'); }
      setShowBotUserForm(false); setEditBotUser(null); loadBotUsers();
    } catch(e) { msg('❌ '+(e.response?.data?.error||e.message)); }
  }

  async function deleteBotUser(id) {
    if(!window.confirm('Silinsin mi?')) return;
    try { await api.delete(`/datebot-manage/${selBot.id}/bot-users/${id}`); msg('🗑️ Silindi'); loadBotUsers(); } catch(e){}
  }

  async function respondBotUser(botUserId, targetId, matchId, action) {
    try {
      const r=await api.post(`/datebot-manage/${selBot.id}/bot-users/${botUserId}/respond`,{target_telegram_id:targetId,action});
      msg(action==='like'?(r.data.matched?'🎉 Eşleşti!':'✅ Beğenildi'):'⏭️ Geçildi');
      if(botUserDetail) { const likes=await api.get(`/datebot-manage/${selBot.id}/bot-users/${botUserDetail.id}/likes`); setBotUserDetail(prev=>({...prev,likes:likes.data})); }
      loadStats();
    } catch(e){ msg('❌ Hata'); }
  }

  async function sendBotMsg(botUserId, matchId, content) {
    try { await api.post(`/datebot-manage/${selBot.id}/bot-users/${botUserId}/send-message`,{match_id:matchId,content}); msg('✅ Gönderildi'); } catch(e){ msg('❌ Hata'); }
  }

  async function banUser(tid,ban) {
    try { await api.patch(`/datebot-manage/${selBot.id}/users/${tid}/ban`,{ban,reason:'Admin kararı'}); msg(ban?'🚫 Banlandı':'✅ Ban kaldırıldı'); loadUsers(); loadStats(); } catch(e){}
  }

  async function setPremium(tid,tier) {
    try { await api.patch(`/datebot-manage/${selBot.id}/users/${tid}/premium`,{tier,days:30}); msg(`✅ ${TIER[tier].i} ${TIER[tier].l} verildi`); } catch(e){}
  }

  async function reviewReport(rid,status,banIt=false) {
    try { await api.patch(`/datebot-manage/${selBot.id}/reports/${rid}`,{status,ban_user:banIt}); msg(banIt?'🚫 Banlandı':'✅ İşlendi'); loadReports(); } catch(e){}
  }

  async function reviewPhoto(id,status) {
    try { await api.patch(`/datebot-manage/${selBot.id}/photo-moderation/${id}`,{status}); msg(status==='approved'?'✅ Onaylandı':'❌ Reddedildi'); loadPhotoMod(); } catch(e){}
  }

  async function addWord() {
    if(!newWord.word) return;
    try { await api.post(`/datebot-manage/${selBot.id}/word-filter`,newWord); setNewWord({word:'',action:'warn'}); loadWordFilter(); } catch(e){}
  }

  async function deleteWord(id) {
    try { await api.delete(`/datebot-manage/${selBot.id}/word-filter/${id}`); loadWordFilter(); } catch(e){}
  }

  async function sendAdminMessage() {
    if (!adminMsg.trim() || !selChat) return;
    setSendingMsg(true);
    try {
      // Bot kullanıcı mı gerçek kullanıcı mı bul
      const botUserId = selChat.bot1_name ? selChat.user1_telegram_id : 
                        selChat.bot2_name ? selChat.user2_telegram_id : null;
      const isBotChat = botUserId && parseInt(botUserId) < 0;
      
      if (isBotChat) {
        // Bot kullanıcı chat - dateBotManagement üzerinden
        const botUserRes = await api.get(`/datebot-manage/${selBot.id}/bot-users`, {
          params: { fake_id: botUserId }
        });
        // Direkt mesaj endpoint
        await api.post(`/datebot-manage/${selBot.id}/admin-send`, {
          match_id: selChat.id,
          content: adminMsg,
          bot_user_telegram_id: botUserId,
        });
      } else {
        await api.post(`/datebot-manage/${selBot.id}/admin-send`, {
          match_id: selChat.id,
          content: adminMsg,
        });
      }
      setAdminMsg('');
      await loadChatMessages(selChat.id);
      msg('✅ Mesaj gönderildi');
    } catch(e) { msg('❌ ' + (e.response?.data?.error || e.message)); }
    setSendingMsg(false);
  }

  async function saveSettings() {
    try { await api.put(`/datebot-manage/${selBot.id}/settings`,settings); msg('✅ Kaydedildi'); setShowSettings(false); } catch(e){ msg('❌ Hata'); }
  }

  const pm = stats.premium||{};
  const totalPremium = (parseInt(pm.plus)||0)+(parseInt(pm.gold)||0);

  const TABS = [
    {k:'overview',l:'📊 Genel'},
    {k:'bot-users',l:`🤖 Bot Kullanıcılar (${botUsers.length})`},
    {k:'real-users',l:`👥 Kullanıcılar (${userTotal})`},
    {k:'chats',l:`💬 Chat İzleme (${chatTotal})`},
    {k:'reports',l:`🚩 Şikayetler${reports.length?` (${reports.length})`:''}`},
    {k:'photo-mod',l:`📸 Fotoğraf${photoMod.length?` (${photoMod.length})`:''}` },
    {k:'word-filter',l:'🔤 Kelime Filtresi'},
  ];

  if(!bots.length) return (
    <div className="page-enter" style={{ display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',minHeight:'60vh',gap:16,textAlign:'center' }}>
      <Toast msg={toast}/>
      <div style={{ fontSize:64, opacity:0.15 }}>💕</div>
      <h2 style={{ fontSize:22, fontWeight:800, fontFamily:'Plus Jakarta Sans' }}>Henüz Date Bot yok</h2>
      <p style={{ color:'var(--text3)', fontSize:14, maxWidth:400 }}>Telegram'dan yeni bir bot oluşturup buraya ekleyebilirsin.</p>
      <button className="btn btn-primary" style={{ padding:'12px 28px' }} onClick={()=>setShowAddBot(true)}>💕 İlk Date Botunu Ekle</button>
      {showAddBot&&<AddBotModal form={addForm} setForm={setAddForm} onSubmit={addBotFn} loading={addLoading} onClose={()=>setShowAddBot(false)}/>}
    </div>
  );

  return (
    <div className="page-enter">
      <Toast msg={toast}/>

      {/* Header */}
      <div className="flex-between mb-20">
        <div>
          <h1 style={{ fontSize:22, fontWeight:800, fontFamily:'Plus Jakarta Sans', marginBottom:3 }}>💕 Date Bot</h1>
          <p style={{ color:'var(--text3)', fontSize:13 }}>Flört botu yönetim paneli</p>
        </div>
        <div className="flex gap-8">
          <button className="btn btn-ghost btn-sm" onClick={()=>{loadStats();loadBotUsers();loadUsers();}}>🔄</button>
          <button className="btn btn-ghost btn-sm" onClick={()=>setShowSettings(true)}>⚙️ Ayarlar</button>
          <button className="btn btn-primary btn-sm" onClick={()=>setShowAddBot(true)}>+ Bot Ekle</button>
        </div>
      </div>

      {/* Bot seçici */}
      <div style={{ display:'flex', gap:10, marginBottom:20, flexWrap:'wrap' }}>
        {bots.map(bot=>(
          <div key={bot.id} onClick={()=>setSelBot(bot)} style={{
            display:'flex', alignItems:'center', gap:10, padding:'10px 16px', borderRadius:'var(--radius)',
            cursor:'pointer', transition:'all 0.15s', minWidth:180,
            background:selBot?.id===bot.id?'var(--accent)':'var(--surface)',
            border:`1.5px solid ${selBot?.id===bot.id?'var(--accent)':'var(--border3)'}`,
            color:selBot?.id===bot.id?'#fff':'var(--text)',
            boxShadow:selBot?.id===bot.id?'0 4px 14px rgba(232,0,10,0.25)':'var(--shadow-sm)',
          }}>
            <span style={{ fontSize:18 }}>💕</span>
            <div>
              <div style={{ fontSize:13, fontWeight:700 }}>{bot.name}</div>
              <div style={{ fontSize:11, opacity:0.7 }}>{bot.total_users||0} kullanıcı</div>
            </div>
            {bot.pending_reports>0&&<span style={{ marginLeft:'auto', background:'#ef4444', color:'#fff', fontSize:10, borderRadius:10, padding:'2px 6px', fontWeight:700 }}>{bot.pending_reports}🚩</span>}
          </div>
        ))}
      </div>

      {selBot&&<>
        {/* Stats */}
        <div style={{ display:'flex', gap:10, marginBottom:20, flexWrap:'wrap' }}>
          <StatBox label="Kullanıcı" value={stats.users?.total} icon="👥" color="var(--teal)" topColor="var(--teal)" sub={`♂${stats.users?.male||0} ♀${stats.users?.female||0}`}/>
          <StatBox label="Bugün Aktif" value={stats.users?.active_today} icon="🔥" color="var(--success)" topColor="var(--success)"/>
          <StatBox label="Eşleşme" value={stats.matches?.active} icon="💕" color="var(--accent)" topColor="var(--accent)" sub={`${stats.matches?.total||0} toplam`}/>
          <StatBox label="Beğeni" value={stats.likes?.total} icon="❤️" color="#ec4899" topColor="#ec4899" sub={`${stats.likes?.super||0} süper`}/>
          <StatBox label="Premium" value={totalPremium} icon="⭐" color="var(--warning)" topColor="var(--warning)" sub={`${pm.gold||0}💛 ${pm.plus||0}💙`}/>
          <StatBox label="Stars" value={`${stats.payments?.total_stars||0}⭐`} icon="💫" color="#8b5cf6" topColor="#8b5cf6"/>
          <StatBox label="Bot Users" value={botUsers.length} icon="🤖" color="var(--info)" topColor="var(--info)" sub={`${botUsers.filter(b=>b.gender==='female').length}♀ ${botUsers.filter(b=>b.gender==='male').length}♂`}/>
          <StatBox label="Şikayet" value={stats.reports?.pending} icon="🚩" color="var(--danger)" topColor="var(--danger)"/>
        </div>

        {/* Tabs */}
        <div className="tabs mb-20" style={{ flexWrap:'wrap' }}>
          {TABS.map(t=><button key={t.k} className={`tab ${tab===t.k?'active':''}`} onClick={()=>setTab(t.k)} style={{ fontSize:12 }}>{t.l}</button>)}
        </div>

        {/* ══ GENEL ══ */}
        {tab==='overview'&&(
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:16 }}>
            <div className="card">
              <div style={{ fontSize:14, fontWeight:700, marginBottom:14 }}>👤 Cinsiyet Dağılımı</div>
              {[{l:'Erkek',c:stats.users?.male||0,col:'#3b82f6'},{l:'Kadın',c:stats.users?.female||0,col:'#ec4899'}].map(g=>{
                const pct=stats.users?.total>0?Math.round((g.c/stats.users.total)*100):0;
                return <div key={g.l} style={{ marginBottom:10 }}>
                  <div style={{ display:'flex', justifyContent:'space-between', fontSize:13, marginBottom:4 }}><span>{g.l}</span><span style={{ fontWeight:700 }}>{g.c} (%{pct})</span></div>
                  <div style={{ height:8, background:'var(--surface3)', borderRadius:4, overflow:'hidden' }}><div style={{ height:'100%', width:`${pct}%`, background:g.col, borderRadius:4 }}/></div>
                </div>;
              })}
            </div>
            <div className="card">
              <div style={{ fontSize:14, fontWeight:700, marginBottom:14 }}>🤖 Bot Kullanıcı Özeti</div>
              {[{l:'Toplam',v:botUsers.length,c:'var(--teal)'},{l:'Kadın',v:botUsers.filter(b=>b.gender==='female').length,c:'#ec4899'},{l:'Erkek',v:botUsers.filter(b=>b.gender==='male').length,c:'#3b82f6'},{l:'Aktif',v:botUsers.filter(b=>b.is_active).length,c:'var(--success)'},{l:'Oto-Beğeni',v:botUsers.filter(b=>b.auto_like_enabled).length,c:'var(--warning)'}].map(s=>(
                <div key={s.l} style={{ display:'flex', justifyContent:'space-between', padding:'6px 0', borderBottom:'1px solid var(--border3)', fontSize:13 }}>
                  <span style={{ color:'var(--text2)' }}>{s.l}</span><span style={{ fontWeight:700, color:s.c }}>{s.v}</span>
                </div>
              ))}
            </div>
            <div className="card">
              <div style={{ fontSize:14, fontWeight:700, marginBottom:14 }}>📈 Metrikler</div>
              {[
                {l:'Eşleşme/Kullanıcı',v:stats.users?.total>0?((stats.matches?.total||0)/stats.users.total).toFixed(2):'—'},
                {l:'Premium Oran',v:stats.users?.total>0?`%${Math.round(totalPremium/(stats.users?.total||1)*100)}`:'—'},
                {l:'Stars/İşlem',v:stats.payments?.txn_count>0?Math.round((stats.payments?.total_stars||0)/(stats.payments.txn_count||1)):'—'},
                {l:'Bekleyen Fotoğraf',v:photoMod.length},
                {l:'Kelime Filtresi',v:wordFilter.length+' kelime'},
              ].map(m=>(
                <div key={m.l} style={{ display:'flex', justifyContent:'space-between', padding:'6px 0', borderBottom:'1px solid var(--border3)', fontSize:13 }}>
                  <span style={{ color:'var(--text2)' }}>{m.l}</span><span style={{ fontWeight:700 }}>{m.v}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ══ BOT KULLANICILAR ══ */}
        {tab==='bot-users'&&(
          <div>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:14, flexWrap:'wrap', gap:10 }}>
              <div className="flex gap-6">
                {[['all','Tümü'],['female','Kadın 👩'],['male','Erkek 👨']].map(([v,l])=>(
                  <button key={v} className={`btn btn-sm ${botUserFilter===v?'btn-primary':'btn-ghost'}`}
                    onClick={()=>{ setBotUserFilter(v); setTimeout(loadBotUsers,50); }}>{l}</button>
                ))}
              </div>
              <button className="btn btn-primary btn-sm" onClick={()=>{ setEditBotUser(null); setShowBotUserForm(true); }}>+ Bot Kullanıcı Ekle</button>
            </div>

            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))', gap:12 }}>
              {botUsers.map(bu=>(
                <div key={bu.id} style={{ background:'var(--surface)', border:'1px solid var(--border3)', borderRadius:'var(--radius)', padding:16, transition:'all 0.15s' }}
                  className="card">
                  <div style={{ display:'flex', gap:10, marginBottom:12, alignItems:'flex-start' }}>
                    <Avatar name={bu.display_name} size={46}/>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ fontWeight:700, fontSize:15 }}>{bu.display_name}, {bu.age}</div>
                      <div style={{ fontSize:12, color:'var(--text3)' }}>{bu.gender==='female'?'♀ Kadın':'♂ Erkek'} · {bu.city}</div>
                      <div style={{ display:'flex', gap:4, marginTop:4, flexWrap:'wrap' }}>
                        {bu.is_active ? <Badge color="var(--success)" bg="var(--success-s)">✅ Aktif</Badge> : <Badge>⏸️ Pasif</Badge>}
                        {bu.auto_like_enabled && <Badge color="var(--warning)" bg="var(--warning-s)">🤖 Oto-Beğeni</Badge>}
                        {bu.show_to_all_cities && <Badge color="var(--teal)" bg="var(--teal-s)">🌍 Tüm Şehir</Badge>}
                      </div>
                    </div>
                  </div>

                  {bu.bio && <div style={{ fontSize:12, color:'var(--text2)', marginBottom:10, lineHeight:1.5, background:'var(--surface3)', padding:'8px 10px', borderRadius:6 }}>{bu.bio.substring(0,80)}{bu.bio.length>80?'...':''}</div>}

                  <div style={{ display:'flex', gap:8, marginBottom:10, fontSize:11, color:'var(--text3)' }}>
                    <span>💕 {bu.match_count||0} eşleşme</span>
                    <span>·</span>
                    <span>🔴 {bu.pending_likes||0} bekleyen</span>
                    <span>·</span>
                    <span>💬 {bu.total_messages_sent||0} mesaj</span>
                  </div>

                  {bu.photos_missing && <div style={{ fontSize:11, color:'var(--warning)', background:'rgba(217,119,6,0.1)', padding:'4px 8px', borderRadius:5, marginBottom:8 }}>⚠️ Görsel eksik (min 2 gerekli)</div>}

                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:6 }}>
                    <button className="btn btn-primary btn-xs" style={{ justifyContent:'center' }} onClick={async()=>{ const r=await api.get(`/datebot-manage/${selBot.id}/bot-users/${bu.id}/likes`); setBotUserDetail({...bu,likes:r.data}); }}>👁️ Beğeniler</button>
                    <button className="btn btn-ghost btn-xs" style={{ justifyContent:'center' }} onClick={()=>{ setEditBotUser(bu); setShowBotUserForm(true); }}>✏️ Düzenle</button>
                    <button className="btn btn-danger btn-xs" style={{ justifyContent:'center' }} onClick={()=>deleteBotUser(bu.id)}>🗑</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ══ KULLANICILAR ══ */}
        {tab==='real-users'&&(
          <div>
            <div style={{ display:'flex', gap:8, marginBottom:14, flexWrap:'wrap' }}>
              <input className="input" style={{ width:220, fontSize:13 }} placeholder="🔍 Ara..." value={userSearch} onChange={e=>setUserSearch(e.target.value)}/>
              {[['all','Tümü'],['premium','Premium'],['banned','Banlı'],['reported','Şikayet'],['nophoto','Fotoğrafsız'],['active','Bugün Aktif']].map(([v,l])=>(
                <button key={v} className={`btn btn-xs ${userFilter===v?'btn-primary':'btn-ghost'}`} onClick={()=>setUserFilter(v)}>{l}</button>
              ))}
            </div>
            <div className="card" style={{ padding:0 }}>
              <div className="table-wrap">
                <table>
                  <thead><tr><th>Kullanıcı</th><th>Bilgi</th><th>Premium</th><th>Eşleşme</th><th>Beğeni</th><th>Şikayet</th><th>Son Aktif</th><th>Durum</th><th>İşlem</th></tr></thead>
                  <tbody>
                    {users.map(u=>(
                      <tr key={u.telegram_id}>
                        <td><div style={{ display:'flex', alignItems:'center', gap:8 }}><Avatar name={u.display_name} size={32}/><div><div style={{ fontWeight:600, fontSize:13 }}>{u.display_name}</div><div style={{ fontSize:11, color:'var(--text3)' }}>@{u.username||u.telegram_id}</div></div></div></td>
                        <td style={{ fontSize:12 }}>{u.age}y · {u.gender==='male'?'♂':'♀'} · {u.city||'—'}</td>
                        <td><Badge color={TIER[u.premium_tier||'free'].c} bg={`${TIER[u.premium_tier||'free'].c}15`}>{TIER[u.premium_tier||'free'].i} {TIER[u.premium_tier||'free'].l}</Badge></td>
                        <td style={{ fontWeight:700, color:'var(--accent)', textAlign:'center' }}>{u.match_count||0}</td>
                        <td style={{ fontWeight:700, color:'var(--success)', textAlign:'center' }}>{u.likes_recv||0}</td>
                        <td style={{ textAlign:'center' }}>{parseInt(u.report_count)>0&&<Badge color="var(--danger)" bg="var(--danger-s)">🚩{u.report_count}</Badge>}</td>
                        <td style={{ fontSize:11, color:'var(--text3)' }}>{new Date(u.last_active).toLocaleDateString('tr-TR')}</td>
                        <td>{u.is_banned?<Badge color="var(--danger)" bg="var(--danger-s)">🚫</Badge>:u.profile_completed?<Badge color="var(--success)" bg="var(--success-s)">✅</Badge>:<Badge>⏳</Badge>}</td>
                        <td><div style={{ display:'flex', gap:3 }}>
                          <button className="btn btn-ghost btn-xs" onClick={async()=>{ const r=await api.get(`/datebot-manage/${selBot.id}/users/${u.telegram_id}`); setUserDetail(r.data); }}>👁️</button>
                          {u.is_banned?<button className="btn btn-success btn-xs" onClick={()=>banUser(u.telegram_id,false)}>✅</button>:<button className="btn btn-danger btn-xs" onClick={()=>banUser(u.telegram_id,true)}>🚫</button>}
                        </div></td>
                      </tr>
                    ))}
                    {!users.length&&<tr><td colSpan={9} style={{ textAlign:'center', padding:30, color:'var(--text3)' }}>Kullanıcı bulunamadı</td></tr>}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* ══ CHAT İZLEME ══ */}
        {tab==='chats'&&(
          <div style={{ display:'grid', gridTemplateColumns:'320px 1fr', gap:16, height:'70vh' }}>
            {/* Chat listesi */}
            <div style={{ background:'var(--surface)', border:'1px solid var(--border3)', borderRadius:'var(--radius)', overflow:'hidden', display:'flex', flexDirection:'column' }}>
              <div style={{ padding:'10px 14px', borderBottom:'1px solid var(--border3)' }}>
                <input className="input" style={{ fontSize:12 }} placeholder="🔍 Chat ara..." value={chatSearch} onChange={e=>setChatSearch(e.target.value)}/>
              </div>
              <div style={{ flex:1, overflowY:'auto' }}>
                {chats.map(c=>{
                  const u1name = c.bot1_name || c.user1_name || '?';
                  const u2name = c.bot2_name || c.user2_name || '?';
                  const isBot1 = !!c.bot1_name, isBot2 = !!c.bot2_name;
                  return (
                    <div key={c.id} onClick={()=>{ setSelChat(c); loadChatMessages(c.id); }}
                      style={{ padding:'10px 14px', borderBottom:'1px solid var(--border3)', cursor:'pointer', background:selChat?.id===c.id?'var(--surface2)':'transparent', transition:'background 0.1s' }}>
                      <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}>
                        <span style={{ fontSize:13, fontWeight:600 }}>
                          {isBot1?'🤖':''}{u1name} & {isBot2?'🤖':''}{u2name}
                        </span>
                        <span style={{ fontSize:10, color:'var(--text3)' }}>{c.msg_count||0} mesaj</span>
                      </div>
                      <div style={{ fontSize:11, color:'var(--text3)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{c.last_msg||'—'}</div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Mesajlar */}
            <div style={{ background:'var(--surface)', border:'1px solid var(--border3)', borderRadius:'var(--radius)', overflow:'hidden', display:'flex', flexDirection:'column' }}>
              {!selChat ? (
                <div style={{ flex:1, display:'flex', alignItems:'center', justifyContent:'center', color:'var(--text3)', fontSize:14 }}>💬 Sol taraftan bir sohbet seç</div>
              ) : (
                <>
                  <div style={{ padding:'12px 16px', borderBottom:'1px solid var(--border3)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <div style={{ fontSize:14, fontWeight:700 }}>
                      {selChat.bot1_name||selChat.user1_name} & {selChat.bot2_name||selChat.user2_name}
                    </div>
                    <div style={{ fontSize:11, color:'var(--text3)' }}>Match #{selChat.id} · {selChat.msg_count} mesaj</div>
                  </div>
                  <div style={{ flex:1, overflowY:'auto', padding:16, display:'flex', flexDirection:'column', gap:8 }}>
                    {chatMessages.map((m,i)=>{
                      const isBot = m.is_bot_sender;
                      const senderName = m.bot_sender_name || m.sender_name || '?';
                      return (
                        <div key={i} style={{ display:'flex', gap:8, alignItems:'flex-start' }}>
                          <Avatar name={senderName} size={28}/>
                          <div style={{ flex:1 }}>
                            <div style={{ fontSize:11, color:'var(--text3)', marginBottom:3 }}>
                              {isBot?'🤖':''}<b>{senderName}</b> · {new Date(m.created_at).toLocaleTimeString('tr-TR',{hour:'2-digit',minute:'2-digit'})}
                              {m.is_flagged&&<span style={{ color:'var(--danger)', marginLeft:6 }}>🚩 Filtrelendi</span>}
                              {m.admin_sent&&<span style={{ color:'var(--warning)', marginLeft:6 }}>👤 Admin</span>}
                            </div>
                            {m.media_type==='photo' ? (
                              <div style={{ background:'var(--surface3)', padding:8, borderRadius:8, fontSize:12, color:'var(--text2)' }}>
                                📸 Fotoğraf {m.content&&`— ${m.content}`}
                              </div>
                            ) : (
                              <div style={{ background:'var(--surface3)', padding:'8px 12px', borderRadius:8, fontSize:13, color:'var(--text)' }}>
                                {m.content||'—'}
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                    {!chatMessages.length&&<div style={{ textAlign:'center', color:'var(--text3)', padding:30 }}>Henüz mesaj yok</div>}
                    <div ref={chatEndRef}/>
                  </div>
                  {/* Admin mesaj kutusu */}
                  <div style={{ padding:'10px 14px', borderTop:'1px solid var(--border3)', background:'var(--surface2)' }}>
                    <div style={{ fontSize:11, color:'var(--text3)', marginBottom:6 }}>
                      👤 Admin olarak yaz — 
                      {selChat?.bot1_name ? ` ${selChat.bot1_name} adına` : selChat?.bot2_name ? ` ${selChat.bot2_name} adına` : ' anonim olarak'}
                    </div>
                    <div style={{ display:'flex', gap:8 }}>
                      <input
                        className="input"
                        style={{ flex:1, fontSize:13 }}
                        placeholder="Mesaj yaz... (Enter ile gönder)"
                        value={adminMsg}
                        onChange={e => setAdminMsg(e.target.value)}
                        onKeyDown={e => { if(e.key==='Enter' && !e.shiftKey) { e.preventDefault(); sendAdminMessage(); } }}
                      />
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={sendAdminMessage}
                        disabled={sendingMsg || !adminMsg.trim()}
                        style={{ flexShrink:0 }}
                      >
                        {sendingMsg ? '⏳' : '📤 Gönder'}
                      </button>
                    </div>
                    {/* Hızlı cevaplar */}
                    <div style={{ display:'flex', gap:5, marginTop:6, flexWrap:'wrap' }}>
                      {['Merhaba! 😊', 'Nasılsın?', 'Çok güzel profil ✨', 'Nerelisin?', 'Ne iş yapıyorsun?'].map((qr,i) => (
                        <button key={i} onClick={() => setAdminMsg(qr)}
                          style={{ fontSize:11, padding:'3px 10px', borderRadius:20, cursor:'pointer', border:'1px solid var(--border)', background:'var(--surface)', color:'var(--text2)' }}>
                          {qr}
                        </button>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* ══ ŞİKAYETLER ══ */}
        {tab==='reports'&&(
          <div className="card" style={{ padding:0 }}>
            <div style={{ padding:'12px 18px', borderBottom:'1px solid var(--border3)' }}><div style={{ fontSize:14, fontWeight:700 }}>🚩 Bekleyen Şikayetler</div></div>
            <div className="table-wrap">
              <table>
                <thead><tr><th>Şikayetçi</th><th>Şikayet Edilen</th><th>Sebep</th><th>Tarih</th><th>İşlem</th></tr></thead>
                <tbody>
                  {reports.map(rep=>(
                    <tr key={rep.id}>
                      <td style={{ fontSize:13 }}>{rep.reporter_name||rep.reporter_telegram_id}</td>
                      <td><div style={{ display:'flex', alignItems:'center', gap:8 }}><Avatar name={rep.reported_name||'?'} size={28}/><span style={{ fontSize:13, fontWeight:600 }}>{rep.reported_name||rep.reported_telegram_id}</span></div></td>
                      <td><Badge color="var(--danger)" bg="var(--danger-s)">{REPORT_REASONS[rep.reason]||rep.reason}</Badge></td>
                      <td style={{ fontSize:12, color:'var(--text3)' }}>{new Date(rep.created_at).toLocaleString('tr-TR')}</td>
                      <td><div style={{ display:'flex', gap:4 }}>
                        <button className="btn btn-danger btn-xs" onClick={()=>reviewReport(rep.id,'reviewed',true)}>🚫 Banla</button>
                        <button className="btn btn-ghost btn-xs" onClick={()=>reviewReport(rep.id,'reviewed',false)}>✅ Geç</button>
                        <button className="btn btn-ghost btn-xs" onClick={()=>reviewReport(rep.id,'dismissed')}>❌ Reddet</button>
                      </div></td>
                    </tr>
                  ))}
                  {!reports.length&&<tr><td colSpan={5} style={{ textAlign:'center', padding:30, color:'var(--text3)' }}>🎉 Bekleyen şikayet yok!</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* ══ FOTOĞRAF MODERASYON ══ */}
        {tab==='photo-mod'&&(
          <div>
            {photoMod.length===0 ? (
              <div className="card" style={{ textAlign:'center', padding:40, color:'var(--text3)' }}>📸 Bekleyen fotoğraf yok</div>
            ) : (
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(220px,1fr))', gap:12 }}>
                {photoMod.map(p=>(
                  <div key={p.id} className="card">
                    <div style={{ width:'100%', height:160, background:'var(--surface3)', borderRadius:8, marginBottom:10, display:'flex', alignItems:'center', justifyContent:'center', fontSize:40, overflow:'hidden' }}>
                      📸
                    </div>
                    <div style={{ fontSize:13, fontWeight:600, marginBottom:2 }}>{p.display_name}, {p.age}</div>
                    <div style={{ fontSize:11, color:'var(--text3)', marginBottom:10 }}>{p.photo_index===0?'Ana fotoğraf':'2. fotoğraf'}</div>
                    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:6 }}>
                      <button className="btn btn-success btn-sm" style={{ justifyContent:'center' }} onClick={()=>reviewPhoto(p.id,'approved')}>✅ Onayla</button>
                      <button className="btn btn-danger btn-sm" style={{ justifyContent:'center' }} onClick={()=>reviewPhoto(p.id,'rejected')}>❌ Reddet</button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* ══ KELİME FİLTRESİ ══ */}
        {tab==='word-filter'&&(
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
            <div className="card">
              <div style={{ fontSize:14, fontWeight:700, marginBottom:14 }}>🔤 Kelime Ekle</div>
              <div className="input-group">
                <label>Kelime</label>
                <input className="input" value={newWord.word} onChange={e=>setNewWord(w=>({...w,word:e.target.value}))} placeholder="Yasaklı kelime..."/>
              </div>
              <div className="input-group">
                <label>Aksiyon</label>
                <select className="input" value={newWord.action} onChange={e=>setNewWord(w=>({...w,action:e.target.value}))}>
                  <option value="warn">⚠️ Uyar (mesajı gönder ama işaretle)</option>
                  <option value="delete">🗑️ Sil (mesajı engelle)</option>
                  <option value="ban">🚫 Ban (kullanıcıyı banla)</option>
                </select>
              </div>
              <button className="btn btn-primary btn-sm" onClick={addWord}>+ Ekle</button>
            </div>
            <div className="card" style={{ padding:0 }}>
              <div style={{ padding:'12px 16px', borderBottom:'1px solid var(--border3)', fontSize:14, fontWeight:700 }}>📋 Mevcut Kelimeler ({wordFilter.length})</div>
              <div style={{ maxHeight:300, overflowY:'auto' }}>
                <table>
                  <thead><tr><th>Kelime</th><th>Aksiyon</th><th>İşlem</th></tr></thead>
                  <tbody>
                    {wordFilter.map(w=>(
                      <tr key={w.id}>
                        <td style={{ fontFamily:'monospace', fontSize:13 }}>{w.word}</td>
                        <td><Badge color={w.action==='ban'?'var(--danger)':w.action==='delete'?'var(--warning)':'var(--teal)'} bg={w.action==='ban'?'var(--danger-s)':w.action==='delete'?'var(--warning-s)':'var(--teal-s)'}>{w.action}</Badge></td>
                        <td><button className="btn btn-danger btn-xs" onClick={()=>deleteWord(w.id)}>🗑</button></td>
                      </tr>
                    ))}
                    {!wordFilter.length&&<tr><td colSpan={3} style={{ textAlign:'center', padding:20, color:'var(--text3)' }}>Kelime eklenmemiş</td></tr>}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </>}

      {/* Modaller */}
      {showAddBot&&<AddBotModal form={addForm} setForm={setAddForm} onSubmit={addBotFn} loading={addLoading} onClose={()=>setShowAddBot(false)}/>}
      {showBotUserForm&&selBot&&<BotUserFormModal bot={editBotUser} onSave={saveBotUser} onClose={()=>{setShowBotUserForm(false);setEditBotUser(null);}}/>}
      {botUserDetail&&selBot&&<BotUserDetailModal data={botUserDetail} botId={selBot.id} onRespond={respondBotUser} onSendMsg={sendBotMsg} onClose={()=>setBotUserDetail(null)}/>}
      {userDetail&&<UserDetailModal data={userDetail} onBan={banUser} onPremium={setPremium} onClose={()=>setUserDetail(null)}/>}
      {showSettings&&<SettingsModal settings={settings} setSettings={setSettings} onSave={saveSettings} onClose={()=>setShowSettings(false)}/>}
    </div>
  );
}

// ── ADD BOT MODAL ──────────────────────────────────────
function AddBotModal({ form, setForm, onSubmit, loading, onClose }) {
  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal" style={{ maxWidth:460 }}>
        <h3>💕 Yeni Date Bot Ekle</h3>
        <div style={{ background:'var(--surface3)', borderRadius:8, padding:12, marginBottom:14, fontSize:13, color:'var(--text2)', lineHeight:1.7 }}>
          1. <b>@BotFather</b>'a git → <code>/newbot</code><br/>2. Bot adı ve kullanıcı adını belirle<br/>3. Token'ı kopyala ve buraya yapıştır
        </div>
        <form onSubmit={onSubmit}>
          <div className="input-group"><label>Bot Adı</label><input className="input" value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} placeholder="Örn: Turkey Date Bot" required/></div>
          <div className="input-group"><label>Bot Token</label><input className="input" value={form.token} onChange={e=>setForm(f=>({...f,token:e.target.value}))} placeholder="123456:ABC..." required style={{ fontFamily:'monospace',fontSize:12 }}/></div>
          <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
            <button type="button" className="btn btn-ghost" onClick={onClose}>İptal</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>{loading?'⏳ Bağlanıyor...':'💕 Ekle & Bağla'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

// ── BOT KULLANICI FORM ─────────────────────────────────
function BotUserFormModal({ bot, onSave, onClose }) {
  const [form, setForm] = useState(bot ? {
    display_name:bot.display_name, age:bot.age, gender:bot.gender,
    seeking:bot.seeking||'both', city:bot.city||'İstanbul', bio:bot.bio||'',
    interests:bot.interests||[], show_to_all_cities:bot.show_to_all_cities!==false,
    is_active:bot.is_active!==false, auto_like_enabled:bot.auto_like_enabled||false,
    auto_like_age_min:bot.auto_like_age_min||18, auto_like_age_max:bot.auto_like_age_max||40,
    auto_like_interval:bot.auto_like_interval||30,
    auto_first_message:bot.auto_first_message||'',
    quick_replies:bot.quick_replies||[],
    photo1:bot.photo1||'', photo2:bot.photo2||'',
  } : {
    display_name:'', age:25, gender:'female', seeking:'male', city:'İstanbul', bio:'',
    interests:[], show_to_all_cities:true, is_active:true,
    auto_like_enabled:false, auto_like_age_min:18, auto_like_age_max:40,
    auto_like_interval:30, auto_first_message:'', quick_replies:[],
    photo1:'', photo2:'',
  });

  function toggleInterest(i) {
    const clean = i.replace(/^.*? /,'');
    setForm(f=>({ ...f, interests: f.interests.includes(clean) ? f.interests.filter(x=>x!==clean) : [...f.interests,clean].slice(0,8) }));
  }

  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal" style={{ maxWidth:580, maxHeight:'90vh', overflowY:'auto' }}>
        <h3>{bot?'✏️ Bot Kullanıcı Düzenle':'🤖 Yeni Bot Kullanıcı'}</h3>

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
          <div className="input-group" style={{ marginBottom:0 }}><label>İsim *</label><input className="input" value={form.display_name} onChange={e=>setForm(f=>({...f,display_name:e.target.value}))} placeholder="Zeynep"/></div>
          <div className="input-group" style={{ marginBottom:0 }}><label>Yaş *</label><input type="number" className="input" value={form.age} onChange={e=>setForm(f=>({...f,age:parseInt(e.target.value)||18}))}/></div>
          <div className="input-group" style={{ marginBottom:0 }}>
            <label>Cinsiyet</label>
            <select className="input" value={form.gender} onChange={e=>setForm(f=>({...f,gender:e.target.value}))}>
              <option value="female">👩 Kadın</option>
              <option value="male">👨 Erkek</option>
            </select>
          </div>
          <div className="input-group" style={{ marginBottom:0 }}>
            <label>Şehir</label>
            <select className="input" value={form.city} onChange={e=>setForm(f=>({...f,city:e.target.value}))}>
              {CITIES.map(c=><option key={c} value={c}>{c}</option>)}
            </select>
          </div>
        </div>

        <div className="input-group" style={{ marginTop:10 }}><label>Bio</label><textarea className="input" value={form.bio} onChange={e=>setForm(f=>({...f,bio:e.target.value}))} placeholder="Kısa tanıtım..." style={{ minHeight:60 }}/></div>

        <div style={{ marginBottom:12 }}>
          <label style={{ fontSize:11, fontWeight:600, color:'var(--text2)', display:'block', marginBottom:6 }}>İLGİ ALANLARI ({form.interests.length}/8)</label>
          <div style={{ display:'flex', flexWrap:'wrap', gap:5 }}>
            {INTERESTS.map(i=>{ const clean=i.replace(/^.*? /,''); const sel=form.interests.includes(clean); return <button key={i} type="button" onClick={()=>toggleInterest(i)} style={{ fontSize:11, padding:'3px 10px', borderRadius:20, cursor:'pointer', border:`1px solid ${sel?'var(--teal)':'var(--border)'}`, background:sel?'var(--teal-s)':'transparent', color:sel?'var(--teal)':'var(--text3)' }}>{i}</button>; })}
          </div>
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:10 }}>
          <div className="input-group" style={{ marginBottom:0 }}><label>Fotoğraf 1 (Telegram file_id)</label><input className="input" value={form.photo1} onChange={e=>setForm(f=>({...f,photo1:e.target.value}))} placeholder="AgACAgIAAx.../"/></div>
          <div className="input-group" style={{ marginBottom:0 }}><label>Fotoğraf 2 (Telegram file_id)</label><input className="input" value={form.photo2} onChange={e=>setForm(f=>({...f,photo2:e.target.value}))} placeholder="AgACAgIAAx..."/></div>
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:10 }}>
          {[
            ['is_active','✅ Aktif'],
            ['show_to_all_cities','🌍 Tüm Şehirlere Göster'],
            ['auto_like_enabled','🤖 Oto-Beğeni Aktif'],
          ].map(([k,l])=>(
            <label key={k} style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:13 }}>
              <label className="toggle"><input type="checkbox" checked={form[k]} onChange={e=>setForm(f=>({...f,[k]:e.target.checked}))}/><span className="toggle-slider"/></label>
              {l}
            </label>
          ))}
        </div>

        <div className="input-group"><label>Otomatik İlk Mesaj</label><input className="input" value={form.auto_first_message} onChange={e=>setForm(f=>({...f,auto_first_message:e.target.value}))} placeholder="Eşleşince otomatik gönderilecek mesaj..."/></div>

        <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:16 }}>
          <button className="btn btn-ghost" onClick={onClose}>İptal</button>
          <button className="btn btn-primary" onClick={()=>onSave(form)}>💾 {bot?'Güncelle':'Ekle'}</button>
        </div>
      </div>
    </div>
  );
}

// ── BOT KULLANICI DETAY MODAL ──────────────────────────
function BotUserDetailModal({ data, botId, onRespond, onSendMsg, onClose }) {
  const [msg, setMsg] = useState('');
  const [selLike, setSelLike] = useState(null);
  const likes = data.likes || [];
  const pending = likes.filter(l => !l.match_id);
  const matched = likes.filter(l => l.match_id);

  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal" style={{ maxWidth:640 }}>
        <h3>🤖 {data.display_name} — Beğeniler & Chat</h3>

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:14 }}>
          <div style={{ background:'var(--surface3)', borderRadius:8, padding:12, textAlign:'center' }}>
            <div style={{ fontSize:24, fontWeight:800, color:'var(--accent)' }}>{pending.length}</div>
            <div style={{ fontSize:11, color:'var(--text3)' }}>Yanıt Bekleyen Beğeni</div>
          </div>
          <div style={{ background:'var(--surface3)', borderRadius:8, padding:12, textAlign:'center' }}>
            <div style={{ fontSize:24, fontWeight:800, color:'var(--success)' }}>{matched.length}</div>
            <div style={{ fontSize:11, color:'var(--text3)' }}>Aktif Eşleşme</div>
          </div>
        </div>

        {/* Yanıt bekleyen beğeniler */}
        {pending.length > 0 && (
          <div style={{ marginBottom:16 }}>
            <div style={{ fontSize:13, fontWeight:700, marginBottom:8 }}>⏳ Yanıt Bekleyen ({pending.length})</div>
            <div style={{ display:'flex', flexDirection:'column', gap:8, maxHeight:240, overflowY:'auto' }}>
              {pending.map((l,i)=>(
                <div key={i} style={{ display:'flex', alignItems:'center', gap:10, background:'var(--surface3)', borderRadius:8, padding:'8px 12px' }}>
                  <Avatar name={l.display_name||'?'} size={36}/>
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:13, fontWeight:600 }}>{l.display_name}, {l.age}</div>
                    <div style={{ fontSize:11, color:'var(--text3)' }}>{l.gender==='male'?'♂':'♀'} · {l.city} · {l.like_type==='super_like'?'⭐ Süper Beğeni':'❤️ Beğeni'}</div>
                  </div>
                  <div style={{ display:'flex', gap:5 }}>
                    <button className="btn btn-success btn-xs" onClick={()=>onRespond(data.id,l.telegram_id,null,'like')}>❤️ Beğen</button>
                    <button className="btn btn-ghost btn-xs" onClick={()=>onRespond(data.id,l.telegram_id,null,'pass')}>👎 Geç</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Aktif eşleşmeler — chat */}
        {matched.length > 0 && (
          <div>
            <div style={{ fontSize:13, fontWeight:700, marginBottom:8 }}>💬 Aktif Eşleşmeler ({matched.length})</div>
            <div style={{ display:'flex', flexDirection:'column', gap:8, maxHeight:200, overflowY:'auto' }}>
              {matched.map((l,i)=>(
                <div key={i} style={{ background:'var(--surface3)', borderRadius:8, padding:'8px 12px' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:8 }}>
                    <Avatar name={l.display_name||'?'} size={28}/>
                    <span style={{ fontSize:13, fontWeight:600 }}>{l.display_name}, {l.age}</span>
                    <span style={{ fontSize:11, color:'var(--text3)', marginLeft:'auto' }}>Match #{l.match_id}</span>
                  </div>
                  {selLike?.match_id===l.match_id ? (
                    <div style={{ display:'flex', gap:6 }}>
                      <input className="input" style={{ flex:1, fontSize:12 }} value={msg} onChange={e=>setMsg(e.target.value)} placeholder="Mesaj yaz..." onKeyDown={e=>{ if(e.key==='Enter'&&msg){ onSendMsg(data.id,l.match_id,msg); setMsg(''); setSelLike(null); } }}/>
                      <button className="btn btn-primary btn-xs" onClick={()=>{ if(msg){ onSendMsg(data.id,l.match_id,msg); setMsg(''); setSelLike(null); } }}>Gönder</button>
                      <button className="btn btn-ghost btn-xs" onClick={()=>setSelLike(null)}>✕</button>
                    </div>
                  ) : (
                    <div style={{ display:'flex', gap:4, flexWrap:'wrap' }}>
                      {(data.quick_replies||[]).slice(0,3).map((qr,qi)=>(
                        <button key={qi} className="btn btn-ghost btn-xs" onClick={()=>onSendMsg(data.id,l.match_id,qr)}>{qr.substring(0,20)}</button>
                      ))}
                      <button className="btn btn-primary btn-xs" onClick={()=>setSelLike(l)}>✍️ Yaz</button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {likes.length===0&&<div style={{ textAlign:'center', padding:20, color:'var(--text3)' }}>Henüz beğeni yok</div>}

        <div style={{ display:'flex', justifyContent:'flex-end', marginTop:16 }}>
          <button className="btn btn-ghost" onClick={onClose}>Kapat</button>
        </div>
      </div>
    </div>
  );
}

// ── USER DETAIL MODAL ──────────────────────────────────
function UserDetailModal({ data, onBan, onPremium, onClose }) {
  const p = data.profile;
  if(!p) return null;
  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal" style={{ maxWidth:500 }}>
        <h3>👤 {p.display_name}</h3>
        <div style={{ display:'flex', gap:14, marginBottom:16, flexWrap:'wrap' }}>
          <Avatar name={p.display_name} size={60}/>
          <div>
            <div style={{ fontSize:17, fontWeight:800 }}>{p.display_name}, {p.age}</div>
            <div style={{ fontSize:13, color:'var(--text3)' }}>@{p.username||p.telegram_id} · {p.city} · {p.gender==='male'?'♂':'♀'}</div>
            <div style={{ marginTop:6, display:'flex', gap:5 }}>
              <Badge color={TIER[p.premium_tier||'free'].c} bg={`${TIER[p.premium_tier||'free'].c}15`}>{TIER[p.premium_tier||'free'].i} {TIER[p.premium_tier||'free'].l}</Badge>
              {p.is_banned&&<Badge color="var(--danger)" bg="var(--danger-s)">🚫 Banlı</Badge>}
            </div>
          </div>
        </div>
        {p.bio&&<div style={{ background:'var(--surface3)', borderRadius:8, padding:10, fontSize:13, marginBottom:14 }}>{p.bio}</div>}
        <div style={{ display:'flex', gap:8, marginBottom:14, flexWrap:'wrap' }}>
          {[{l:'Eşleşme',v:p.total_matches,c:'var(--accent)'},{l:'Beğeni',v:p.total_likes_received,c:'var(--success)'},{l:'Mesaj',v:p.total_messages,c:'var(--teal)'}].map(s=>(
            <div key={s.l} style={{ flex:1, textAlign:'center', background:'var(--surface3)', borderRadius:8, padding:'8px 4px' }}>
              <div style={{ fontSize:20, fontWeight:800, color:s.c }}>{s.v||0}</div>
              <div style={{ fontSize:10, color:'var(--text3)' }}>{s.l}</div>
            </div>
          ))}
        </div>
        <div style={{ fontSize:12, fontWeight:600, marginBottom:8 }}>Premium ver:</div>
        <div style={{ display:'flex', gap:6, marginBottom:14, flexWrap:'wrap' }}>
          <button className="btn btn-ghost btn-sm" onClick={()=>onPremium(p.telegram_id,'free')}>🆓 Free</button>
          <button className="btn btn-sm" style={{ background:'#3b82f615', color:'#3b82f6', border:'1px solid #3b82f630' }} onClick={()=>onPremium(p.telegram_id,'plus')}>💙 Plus 30g</button>
          <button className="btn btn-sm" style={{ background:'#d9770615', color:'#d97706', border:'1px solid #d9770630' }} onClick={()=>onPremium(p.telegram_id,'gold')}>💛 Gold 30g</button>
        </div>
        <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
          {p.is_banned?<button className="btn btn-success btn-sm" onClick={()=>onBan(p.telegram_id,false)}>✅ Ban Kaldır</button>:<button className="btn btn-danger btn-sm" onClick={()=>onBan(p.telegram_id,true)}>🚫 Banla</button>}
          <button className="btn btn-ghost btn-sm" onClick={onClose}>Kapat</button>
        </div>
      </div>
    </div>
  );
}

// ── SETTINGS MODAL ─────────────────────────────────────
function SettingsModal({ settings, setSettings, onSave, onClose }) {
  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal" style={{ maxWidth:560 }}>
        <h3>⚙️ Ayarlar</h3>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
          {[
            {k:'free_daily_likes',l:'Ücretsiz Günlük Beğeni'},
            {k:'plus_daily_likes',l:'Plus Günlük Beğeni'},
            {k:'gold_daily_likes',l:'Gold Günlük Beğeni'},
            {k:'plus_monthly_stars',l:'Plus Fiyatı (Stars) ⭐'},
            {k:'gold_monthly_stars',l:'Gold Fiyatı (Stars) ⭐'},
            {k:'auto_ban_reports',l:'Otomatik Ban Eşiği'},
            {k:'city_match_weight',l:'Şehir Ağırlığı (0-1)'},
            {k:'interest_match_weight',l:'İlgi Alanı Ağırlığı (0-1)'},
            {k:'age_match_weight',l:'Yaş Ağırlığı (0-1)'},
            {k:'min_age',l:'Min Yaş'},
          ].map(f=>(
            <div key={f.k} className="input-group" style={{ marginBottom:0 }}>
              <label style={{ fontSize:10 }}>{f.l}</label>
              <input type="number" step="0.1" className="input" value={settings[f.k]||''} onChange={e=>setSettings(s=>({...s,[f.k]:e.target.value}))}/>
            </div>
          ))}
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginTop:12 }}>
          {[['require_photo_approval','Fotoğraf Onayı Zorunlu'],['auto_approve_photos','Otomatik Fotoğraf Onayla'],['word_filter_enabled','Kelime Filtresi Aktif']].map(([k,l])=>(
            <label key={k} style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:13 }}>
              <label className="toggle"><input type="checkbox" checked={settings[k]||false} onChange={e=>setSettings(s=>({...s,[k]:e.target.checked}))}/><span className="toggle-slider"/></label>{l}
            </label>
          ))}
        </div>
        <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:16 }}>
          <button className="btn btn-ghost" onClick={onClose}>İptal</button>
          <button className="btn btn-primary" onClick={onSave}>💾 Kaydet</button>
        </div>
      </div>
    </div>
  );
}
